import { track } from '@bnnvara/analytics/src/track';
import { useBrand } from '@bnnvara/brand';
import { sizes } from '@bnnvara/breakpoints';
import { BaseButton } from '@bnnvara/buttons';
import LazyLoadImage from '@bnnvara/lazy-load';
import { Heading, Text } from '@bnnvara/typography';
import React from 'react';

import * as S from './styled';

const SocialFooter = () => {
  const brand = useBrand();

  if (!brand) {
    return null;
  }

  const socials = [
    { label: 'Facebook', url: brand.facebook },
    { label: 'Twitter', url: brand.twitter },
    { label: 'Instagram', url: brand.instagram },
    { label: 'Youtube', url: brand.youtube },
  ].filter((social) => social.url);

  if (socials.length === 0) {
    return null;
  }

  return (
    <S.SocialContainer aria-label="Een sectie die linkt naar de social media pagina's.">
      <S.SocialBackgroundImg
        srcSet={`
              /static/socialTeaserImages/382-480.png ${sizes.xs}w,
              /static/socialTeaserImages/500-768.png ${sizes.md}w,
              /static/socialTeaserImages/500-1024.png ${sizes.lg}w,
              /static/socialTeaserImages/500-1250.png ${sizes.xl}w,
            `}
        src="/static/socialTeaserImages/500-1250.png"
        alt="social background"
      />

      <S.ContentWrapper>
        <S.ContentContainer>
          <Heading variant="one" element="h2">
            Blijf op de hoogte van {brand.name}.
          </Heading>
          <Text color="white">
            Wil je op de hoogte blijven van {brand.name}? Volg ons dan op onze
            socials!
          </Text>
          <S.ButtonContainer>
            {socials.map(({ url, label }) => (
              <BaseButton
                key={url}
                size="small"
                variant="ghost"
                type="link"
                href={url}
                target="_blank"
                onClick={() =>
                  track('social-footer', 'click', `button-${label}`)
                }
              >
                {label}
              </BaseButton>
            ))}
          </S.ButtonContainer>
        </S.ContentContainer>
        <S.ImageContainer>
          <LazyLoadImage
            as={S.PhoneImage}
            src="/static/socialTeaserImages/phone.png"
            alt="telefoon"
          />
        </S.ImageContainer>
      </S.ContentWrapper>
    </S.SocialContainer>
  );
};

export default SocialFooter;
